
let portNumberLocal = localStorage.getItem('BondTimeportNoData');

let baseUrlToGiveBack = null

if (portNumberLocal) {

    // console.log("portNumber ", portNumberLocal)

    let portNumber = JSON.parse(portNumberLocal)

    // console.log("portNumber ", portNumber)

    // baseUrlToGiveBack = portNumber[0].IMG_POST_PATH
    baseUrlToGiveBack = portNumber[0].IMG_API_PATH

    console.log("baseUrlToGiveBack--> ", baseUrlToGiveBack)


}



export let base_url_image_view_api = baseUrlToGiveBack